/* eslint-disable max-classes-per-file */

const breakpoints = require('../../json/breakpoints.json');

const htmlSelect = document.querySelector('html');
const modalOverlaySelect = document.querySelector('.js-modal');
let scrollTop = 0;
const md = window.matchMedia(`(max-width: ${breakpoints.md})`);

class StyledSelect {
    constructor(select, settings = {}) {
        this.isVisible = false;
        this.className = 'styled-select';
        this.hiddenClassName = `${this.className}-hidden`;

        this.select = select;
        this.select.classList.add(this.hiddenClassName);
        this.options = this.select.children;

        this.settings = settings;
        this.selection = new Map();

        this.trigger = null;
        this.target = null;
        this.container = null;
        this.list = null;
        this.title = null;
        this.closeElement = null;

        this.create();
    }

    createContainer() {
        this.container = document.createElement('div');
        const containerClassName = `${this.className}-container`;
        this.container.classList.add(containerClassName);
        this.container.classList.add(
            `${containerClassName}-${this.settings.name}`
        );
        this.hide();
    }

    createList() {
        if (this.settings.title) {
            this.createListTitle();
        }

        if (this.settings.close) {
            this.createListClose();
        }

        this.list = document.createElement('ul');
        this.list.classList.add(`${this.className}-list`);
        this.container.appendChild(this.list);
    }

    createListTitle() {
        this.title = document.createElement('div');
        this.title.classList.add(`${this.className}-title`);
        this.title.innerHTML = this.settings.title;
        this.container.appendChild(this.title);
    }

    createListClose() {
        const tabindexAttribute = document.createAttribute('tabindex');
        tabindexAttribute.value = '0';

        this.closeElement = document.createElement('a');
        this.closeElement.classList.add(`${this.className}-close`);
        this.closeElement.innerHTML = 'x';
        this.closeElement.setAttributeNode(tabindexAttribute);
        this.closeElement.addEventListener('click', () => this.hide());

        this.closeElement.addEventListener('keypress', function (event) {
            // If the user presses the "Enter" key on the keyboard
            if (event.key === 'Enter') {
                // Cancel the default action, if needed
                event.preventDefault();
                // Trigger the button element with a click
                this.click();
            }
        });

        this.container.appendChild(this.closeElement);
    }

    createListItems() {
        const selectedElements = Array.from(this.options)
            .filter((o) => o.selected)
            .map((o) => o.value);

        // loop options in our list
        for (let i = 0; i < this.options.length; i += 1) {
            const option = this.options[i];

            const id = option.value + this.settings.name;

            // create a label for corresponding input type
            const label = document.createElement('label');
            label.setAttribute('for', id);

            const li = document.createElement('li');

            const input = document.createElement('input');
            input.id = id;
            input.type = this.settings.multiple ? 'checkbox' : 'radio';
            input.disabled = this.settings.readOnly;
            input.value = option.value;

            if (!this.settings.multiple) {
                input.name = `${this.settings.name}-group`;
            }

            const caption = document.createTextNode(option.innerText);

            this.addListItemClickHandler(input, option);

            li.appendChild(input);
            label.appendChild(caption);

            // option.selected is somehow lost inside the loop, except for the first element
            const isSelected = selectedElements.includes(option.value);

            if (isSelected) {
                li.classList.add(`${this.className}-active`);
                input.checked = true;
                this.addValue(input.value);
            } else {
                li.classList.remove(`${this.className}-active`);
                input.checked = false;
            }

            li.appendChild(label);
            this.list.appendChild(li);
        }
    }

    addListItemClickHandler(input, option) {
        input.addEventListener('click', () => {
            if (this.settings.multiple) {
                if (input.checked) {
                    this.addValue(input.value, option.textContent);
                } else {
                    this.removeValue(input.value);
                }
            } else {
                this.addValue(input.value, option.textContent);
            }

            if (typeof this.settings.onChange === 'function') {
                this.settings.onChange(this);
            }
        });
    }

    create() {
        // create DOM context
        this.createContainer();
        // create a list container
        this.createList();
        // generate list items
        this.createListItems();
        // spot the target in the DOM
        this.target = document.querySelector(this.settings.appendTo);
        this.target.appendChild(this.container);
        // set click event voor toggling the list
        this.setToggleVisibilityHandler();
        // register for outside click behavior
        // eslint-disable-next-line no-use-before-define
        StyledSelectsObserver.register(this);
    }

    // eslint-disable-next-line class-methods-use-this
    bodyLock() {
        scrollTop =
            window.pageYOffset !== undefined
                ? window.pageYOffset
                : (
                      document.documentElement ||
                      document.body.parentNode ||
                      document.body
                  ).scrollTop;
        htmlSelect.classList.add('noscroll');
        htmlSelect.style.top = `${-scrollTop}px`;
        htmlSelect.setAttribute('data-scrolldir', 'down');
    }

    // eslint-disable-next-line class-methods-use-this
    bodyLockClear() {
        htmlSelect.classList.remove('noscroll');
        window.scrollTo(0, scrollTop);
        htmlSelect.setAttribute('data-scrolldir', 'up');
    }

    setToggleVisibilityHandler() {
        this.trigger = document.querySelector(this.settings.trigger);
        this.trigger.addEventListener('click', () => this.toggle());
    }

    addValue(value, name) {
        if (!this.settings.multiple) {
            this.selection.clear();
        }

        this.selection.set(value, { value, name });
        this.updateHiddenSelect();
    }

    removeValue(value) {
        this.selection.delete(value);
        this.updateHiddenSelect();
    }

    updateHiddenSelect() {
        for (let i = 0; i < this.options.length; i += 1) {
            const option = this.options[i];
            if (this.selection.has(option.value)) {
                option.setAttribute('selected', 'selected');
            } else {
                option.removeAttribute('selected');
            }
        }

        this.triggerChangeEvent();
    }

    reset() {
        this.list.innerHTML = '';
        this.createListItems();
        this.triggerChangeEvent();
    }

    triggerChangeEvent() {
        const event = document.createEvent('HTMLEvents');
        event.initEvent('change', true, true);
        this.select.dispatchEvent(event);
    }

    hide() {
        this.isVisible = false;
        this.container.classList.add(this.hiddenClassName);
        document.querySelectorAll('.open-button').forEach((button) => {
            button.classList.remove('open-button');
        });
        if (md.matches) {
            if (modalOverlaySelect) {
                if (
                    !modalOverlaySelect.classList.contains('overlay-invisible')
                ) {
                    htmlSelect.dataset.scrolldir = 'up';
                } else {
                    this.bodyLockClear();
                }
            } else {
                this.bodyLockClear();
            }
        }
    }

    show() {
        this.isVisible = true;
        this.container.classList.remove(this.hiddenClassName);
        if (md.matches) {
            this.bodyLock();
        }
    }

    toggle() {
        if (this.isVisible) {
            this.trigger.classList.remove('open-button');
            this.hide();
        } else {
            this.trigger.classList.add('open-button');
            this.show();
        }
    }
}

const StyledSelectsObserver = new (class {
    constructor() {
        this.styledSelects = new Set();
    }

    register(styledSelect) {
        this.styledSelects.add(styledSelect);
        this.bindOutsideClickHandler();
    }

    bindOutsideClickHandler() {
        document.removeEventListener('click', (e) =>
            this.checkOutsideClickHandler(e)
        );
        document.addEventListener('click', (e) =>
            this.checkOutsideClickHandler(e)
        );
    }

    checkOutsideClickHandler({ target }) {
        this.styledSelects.forEach((select) => {
            // ignore the trigger button
            if (target !== select.trigger) {
                const outSideClick = !select.container.contains(target);
                if (outSideClick && select.isVisible) {
                    select.hide();
                    document
                        .querySelectorAll('.open-button')
                        .forEach((button) => {
                            button.classList.remove('open-button');
                        });
                }
            }
        });
    }
})();

module.exports = StyledSelect;
